/* Snackspot v2 — shared site script for the Shapes-based theme.
   Ported from the designer's site-v2.js (2026-09-05). Removed: the localStorage cart, the
   Tweaks panel, the CTA-retarget exploration, the JS-built FAB stack and drawer (all three are
   rendered by Liquid from theme settings). Kept: rupiah(), toast, reveal, drawer behaviour,
   WhatsApp helpers. Added: ssBusy (CLAUDE.md rule 16) and ssCart — the ONLY code that talks to
   Shopify's cart endpoints — and the cart-count sync. */
(function () {
  'use strict';
  var root = document.documentElement;
  var cfg = window.SS || {};
  var routes = cfg.routes || { cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cartJson: '/cart.js' };

  function rupiah(n) { return 'Rp ' + Math.round(n).toLocaleString('id-ID'); }

  // ---------- toast ----------
  function showToast(msg, ms) {
    var t = document.getElementById('toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('show'); });
    clearTimeout(window.__toastT);
    window.__toastT = setTimeout(function () { t.classList.remove('show'); }, ms || 2200);
  }

  // ---------- reveal ----------
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || root.classList.contains('shopify-design-mode')) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---------- busy (rule 16): disable, say what is happening, dim the row, restore on both paths ----------
  function ssBusy(el, label) {
    if (!el || el.getAttribute('aria-busy') === 'true') return null;
    var isInput = el.tagName === 'INPUT';
    var prev = isInput ? el.value : el.innerHTML;
    var row = el.closest('[data-busyrow]');
    el.setAttribute('aria-busy', 'true');
    el.disabled = true;
    if (label) {
      if (isInput) el.value = label;
      else { el.textContent = ''; var sp = document.createElement('span'); sp.className = 'ss-spinner'; sp.setAttribute('aria-hidden', 'true'); el.appendChild(sp); el.appendChild(document.createTextNode(' ' + label)); }
    }
    if (row) row.classList.add('row-busy');
    var done = false;
    return function release() {
      if (done) return; done = true;
      el.removeAttribute('aria-busy');
      el.disabled = false;
      if (label) { if (isInput) el.value = prev; else el.innerHTML = prev; }
      if (row) row.classList.remove('row-busy');
    };
  }

  // ---------- cart ----------
  function announce(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    // cart-scout and Shapes listen to these
    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    window.dispatchEvent(new CustomEvent('cartchange', { detail: cart }));
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j; }); });
  }
  function getCart() { return fetch(routes.cartJson, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function add(items, opts) {
    opts = opts || {};
    return post(routes.cartAdd, { items: items }).then(getCart).then(function (cart) {
      announce(cart);
      if (opts.toast !== false) showToast(opts.toast || 'Added ✓');
      // The v2 drawer, never Shapes'. This used to call Alpine.store('modals').open('cart'),
      // which opened the inherited indigo panel the design never drew — unstyled, subtotal cut
      // off, and carrying the app embed's second ongkir bar. ss-cart-drawer.js owns this now and
      // re-fetches /cart.js on open, so it is correct even if another tab wrote the cart.
      if (cfg.openDrawerOnAdd !== false && window.ssCartDrawer) {
        try { window.ssCartDrawer.open(); } catch (e) {}
      }
      return cart;
    });
  }
  function change(key, quantity) { return post(routes.cartChange, { id: key, quantity: quantity }).then(function (cart) { announce(cart); return cart; }); }
  function update(payload) { return post(routes.cartUpdate, payload).then(function (cart) { announce(cart); return cart; }); }
  function refreshCount() { getCart().then(function (cart) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; }); }).catch(function () {}); }

  // any <form action="/cart/add"> with data-ss-add submits over AJAX with busy feedback
  function wireAddForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-ss-add')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var release = ssBusy(btn, (btn && btn.dataset.ssBusy) || 'Adding…');
      if (btn && !release) return;
      var fd = new FormData(form);
      var id = parseInt(fd.get('id'), 10);
      var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
      add([{ id: id, quantity: qty }], { toast: form.dataset.ssToast || ('Added: ' + (form.dataset.ssName || 'to cart') + ' ✓') })
        .then(function () { if (release) release(); })
        .catch(function (err) { if (release) release(); showToast(err.message || 'Could not add — try again'); });
    });
  }

  // ---------- WhatsApp ----------
  function waLink(text) {
    var n = cfg.waNumber || '6282146459863';
    return 'https://wa.me/' + n + (text ? ('?text=' + encodeURIComponent(text)) : '');
  }

  // ---------- mobile drawer (markup is rendered by ss-header.liquid) ----------
  function initMobileNav() {
    var burger = document.querySelector('.nav2-burger');
    var drawer = document.getElementById('mnav');
    if (!burger || !drawer) return;
    var panel = drawer.querySelector('.mnav-panel');
    var main = document.getElementById('MainContent');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      document.body.classList.add('mnav-open', 'menu-open');
      burger.setAttribute('aria-expanded', 'true');
      if (main) main.setAttribute('inert', '');
      var first = panel.querySelector('.mnav-close'); if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('mnav-open', 'menu-open');
      burger.setAttribute('aria-expanded', 'false');
      if (main) main.removeAttribute('inert');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    burger.addEventListener('click', function () { drawer.classList.contains('is-open') ? close() : open(); });
    drawer.querySelectorAll('[data-mnav-close]').forEach(function (el) { el.addEventListener('click', close); });
    drawer.querySelectorAll('.mnav-links a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth > 960 && drawer.classList.contains('is-open')) close(); });
  }

  // ---------- header height → CSS var (sticky offsets for page bars) ----------
  function measureNav() {
    var nav = document.querySelector('.nav2');
    if (!nav) return;
    var h = nav.getBoundingClientRect().height;
    // cart-scout inserts its bar and a spacer as the first children of <body>; whatever they take
    // up sits above the sticky header, so page-level sticky bars must clear both
    ['snackspot-ss-bar', 'snackspot-ss-spacer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.offsetParent !== null) h += el.getBoundingClientRect().height;
    });
    root.style.setProperty('--ss-nav-h', Math.round(h) + 'px');
  }

  // ---------- init ----------
  function watchHeaderOffset() {
    measureNav();
    window.addEventListener('resize', measureNav);
    window.addEventListener('resize', fillMarquees);
    // the cart-scout bar arrives after its own fetch and resizes with its message
    ['theme:cart:change', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(measureNav, 120); }); });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { measureNav(); });
      ['snackspot-ss-bar', 'snackspot-ss-spacer'].forEach(function (id) { var el = document.getElementById(id); if (el) ro.observe(el); });
      if (window.MutationObserver) {
        new MutationObserver(function () {
          ['snackspot-ss-bar', 'snackspot-ss-spacer'].forEach(function (id) { var el = document.getElementById(id); if (el && !el.__ssObserved) { el.__ssObserved = true; ro.observe(el); measureNav(); } });
        }).observe(document.body, { childList: true });
      }
    }
  }

  // ---------- marquees: enough copies that a half always covers the viewport ----------
  // The track scrolls 0 → -50%, so each half must be at least as wide as the window or the strip
  // runs out and shows blank. Liquid doubles the item list, which is enough on the homepage and
  // not on the product page, where the claims are short (2046 px of track for a 1440 px window —
  // a 417 px hole). The right count depends on the viewport, so it is decided here, not in Liquid.
  function fillMarquees() {
    document.querySelectorAll('.announce-track, .tape-track').forEach(function (track) {
      if (!track.children.length) return;
      if (!track.ssSet) {
        var half = Math.max(1, Math.round(track.children.length / 2));
        track.ssSet = Array.prototype.slice.call(track.children, 0, half).map(function (n) { return n.cloneNode(true); });
      }
      var set = track.ssSet;
      if (!set.length) return;
      var copies = Math.max(1, Math.round(track.children.length / set.length));
      var setW = track.scrollWidth / copies;
      if (!setW) return;
      var need = Math.min(16, Math.max(2, 2 * Math.ceil(window.innerWidth / setW)));
      if (need === copies) return;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < need; i++) set.forEach(function (n) { frag.appendChild(n.cloneNode(true)); });
      track.textContent = '';
      track.appendChild(frag);
    });
  }


  /* Mode B's cut-out is a MERCHANT ASSERTION, not a fact Shopify can check: Liquid cannot decode
     an image and there is no "is transparent" property, and a .png extension proves nothing —
     product-almond-bag.png is a fully opaque PNG. So a merchant can upload an opaque photo into
     the card_cutout field, and Mode B would then draw a rectangular shadow around it: exactly the
     bug this whole system exists to prevent.

     This samples the four corners' alpha once the cut-out has loaded and demotes the card to
     Mode A if the asset is not really transparent. Fail-open: a canvas that throws (a tainted
     cross-origin draw, a browser blocking canvas reads) leaves the card as authored rather than
     demoting a good cut-out on a false negative. */
  /* The hero pouch is an image the merchant PICKS, so Liquid cannot know whether it is a cut-out.
     Its pink glow only traces the pouch on a transparent asset; on an opaque photo it traces the
     image rectangle. Same corner-alpha test as the cards, and the same fail-open behaviour. */
  function guardHeroBag() {
    var img = document.querySelector('.hero2-photo .bag');
    if (!img) return;
    var check = function () {
      if (!img.naturalWidth) return;
      try {
        var c = document.createElement('canvas'); var n = 8; c.width = c.height = n;
        var x = c.getContext('2d', { willReadFrequently: true });
        var w = img.naturalWidth, h = img.naturalHeight, opaque = 0;
        [[0, 0], [w - n, 0], [0, h - n], [w - n, h - n]].forEach(function (p) {
          x.clearRect(0, 0, n, n);
          x.drawImage(img, p[0], p[1], n, n, 0, 0, n, n);
          var d = x.getImageData(0, 0, n, n).data;
          for (var i = 3; i < d.length; i += 4) { if (d[i] > 250) { opaque++; break; } }
        });
        if (opaque === 4) {
          img.classList.add('is-not-cutout');
          if (window.console) console.warn('[snackspot] the hero bag is an opaque photo, so its pink glow would trace the image rectangle — glow removed. Pick a transparent cut-out, cropped tight.', img.currentSrc || img.src);
        }
      } catch (e) { /* fail open */ }
    };
    if (img.complete) check(); else img.addEventListener('load', check, { once: true });
  }

  function guardCutouts() {
    if (document.body.dataset.cardStyle !== 'breakout') return;
    document.querySelectorAll('.pcard2[data-has-cutout="true"] .ph-cutout').forEach(function (img) {
      var check = function () {
        if (!img.naturalWidth) return;                       // never loaded — leave it alone
        var c = document.createElement('canvas');
        var n = 8;                                           // sample an 8px corner patch, not one pixel
        c.width = c.height = n;
        try {
          var x = c.getContext('2d', { willReadFrequently: true });
          var w = img.naturalWidth, h = img.naturalHeight, opaque = 0;
          [[0, 0], [w - n, 0], [0, h - n], [w - n, h - n]].forEach(function (p) {
            x.clearRect(0, 0, n, n);
            x.drawImage(img, p[0], p[1], n, n, 0, 0, n, n);
            var d = x.getImageData(0, 0, n, n).data;
            for (var i = 3; i < d.length; i += 4) { if (d[i] > 250) { opaque++; break; } }
          });
          // every corner opaque = a rectangular photo, not a cut-out
          if (opaque === 4) {
            img.closest('.pcard2').dataset.hasCutout = 'false';
            if (window.console) console.warn('[snackspot] card_cutout is not transparent — card demoted to full-bleed:', img.currentSrc || img.src);
            return;
          }
          // A transparent but UNTRIMMED canvas is the other way this goes wrong, and it is the one
          // that looks like the theme is broken: the pouch rises exactly as far as it should, but
          // what clears the panel is empty padding, so nothing appears to happen. Measure the ink
          // and say so. Sampling every 8th pixel is plenty to find the bounding box.
          var full = x.canvas;
          full.width = w > 512 ? 512 : w; full.height = Math.round(full.width * h / w);
          x.clearRect(0, 0, full.width, full.height);
          x.drawImage(img, 0, 0, full.width, full.height);
          var fd = x.getImageData(0, 0, full.width, full.height).data;
          var minX = full.width, maxX = -1;
          for (var yy = 0; yy < full.height; yy++) {
            for (var xx = 0; xx < full.width; xx++) {
              if (fd[(yy * full.width + xx) * 4 + 3] > 8) { if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; }
            }
          }
          var share = (maxX - minX + 1) / full.width;
          if (share < 0.85 && window.console) {
            console.warn('[snackspot] card_cutout is padded: the product fills only '
              + Math.round(share * 100) + '% of the image width, so the breakout is mostly empty space. '
              + 'Crop the PNG tight to the product and re-upload.', img.currentSrc || img.src);
          }
        } catch (e) { /* fail open: keep the card as authored */ }
      };
      if (img.complete) check(); else img.addEventListener('load', check, { once: true });
    });
  }

  function init() {
    initReveal();
    fillMarquees();
    initMobileNav();
    wireAddForms();
    watchHeaderOffset();
    refreshCount();
    guardCutouts();
    guardHeroBag();
    document.addEventListener('shopify:section:load', function () { initReveal(); fillMarquees(); measureNav(); guardCutouts(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.ssBusy = ssBusy;
  window.ssToast = showToast;
  window.ssCart = { add: add, change: change, update: update, get: getCart, announce: announce, rupiah: rupiah };
  window.ssWaLink = waLink;
  window.ssRupiah = rupiah;
})();
